import { Autocomplete, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../redux/types'

interface ILanguage {
  id: number
  name: string
}

function LanguageMultiAutocomplete({ value, handleInputChange, type }: any) {
  const { t } = useTranslation(['global'])

  const { languages } = useSelector((state: IRootState) => state.language)
  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  const handleMultiAutoCompleteChange = (languages: ILanguage[]) => {
    let optionsMulti: number[] = []
    if (languages !== null) {
      for (let i = 0; i < languages.length; i++) {
        optionsMulti.push(languages[i].id)
      }
    }

    handleInputChange('languages', optionsMulti)
  }

  return (
    <Autocomplete
      id="multi-autocomplete-languages"
      value={languages.filter((language: any) => value.includes(language.id))}
      onChange={(_, value) => handleMultiAutoCompleteChange(value)}
      options={languages}
      multiple
      limitTags={1}
      sx={type === 1 ? { pt: '3px !important' } : {}}
      getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
      renderInput={params => (
        <TextField
          {...params}
          label={type === 1 ? '' : `${t('languages')}*`}
          variant="filled"
          placeholder={type === 1 ? t('languages') : ''}
          InputLabelProps={{ shrink: type !== 1 }}
          error={errorForm.languages}
          helperText={msgForm.languages}
        />
      )}
    />
  )
}

export default LanguageMultiAutocomplete
